var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnmuteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.434 0.0991679C17.086 -0.0668319 16.676 -0.022832 16.376 0.219168L6.64799 8.00116H2C0.897999 8.00116 0 8.89916 0 10.0012V18.0012C0 19.1052 0.897999 20.0012 2 20.0012H6.64799L16.374 27.7831C16.556 27.9271 16.778 28.0011 17 28.0011C17.148 28.0011 17.296 27.9671 17.434 27.9011C17.78 27.7351 18 27.3851 18 27.0011V1.00117C18 0.617168 17.78 0.267168 17.434 0.0991679Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0619 6.92889C22.6679 6.54089 22.0359 6.54689 21.6479 6.93689C21.2599 7.33089 21.2639 7.96289 21.6559 8.35289C23.1679 9.84488 23.9999 11.8509 23.9999 14.0009C23.9999 16.1509 23.1679 18.1569 21.6559 19.6489C21.2639 20.0349 21.2599 20.6689 21.6479 21.0629C21.8439 21.2609 22.1019 21.3589 22.3579 21.3589C22.6119 21.3589 22.8659 21.2629 23.0619 21.0689C24.9579 19.2029 25.9999 16.6909 25.9999 14.0009C25.9999 11.3109 24.9579 8.79889 23.0619 6.92889Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8844 4.11155C25.4904 3.72155 24.8584 3.72555 24.4684 4.11755C24.0804 4.50955 24.0844 5.14355 24.4744 5.53155C26.7484 7.78555 28.0004 10.7935 28.0004 14.0015C28.0004 17.2095 26.7484 20.2155 24.4744 22.4695C24.0844 22.8595 24.0804 23.4935 24.4684 23.8855C24.6664 24.0815 24.9224 24.1795 25.1784 24.1795C25.4324 24.1795 25.6884 24.0835 25.8844 23.8895C28.5404 21.2595 30.0004 17.7475 30.0004 14.0015C30.0004 10.2555 28.5404 6.74355 25.8844 4.11155Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/unmute-icon.79ace81321920790cdb194cfcaf287d9.svg";
export { ForwardRef as ReactComponent };